import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { ReadRateCommand } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandsDefaultLabels, ProductionFieldName } from '@src/suite/common/utils/ml-2-html-utils';

@Component({
    selector: 'st-read-rate-command-dialog',
    templateUrl: './read-rate-command-dialog.html',
    styleUrls: ['./read-rate-command-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-read-rate-command-dialog' },
})
export class ReadRateCommandDialogComponent {
    public ProductionFieldName = ProductionFieldName;
    public ProductionCommandsDefaultLabels = ProductionCommandsDefaultLabels;
    public command = input<ReadRateCommand>();
    public commandChange = output<ReadRateCommand>();
    public onEnterEmitter = output<ReadRateCommand>();

    public onCommandsObjectChange(event: any, fieldName: ProductionFieldName) {
        if (this.command()) {
            this.command()[fieldName] = event;
            this.commandChange.emit(this.command());
        }
    }

    public onEnterSaveCommand(event: any) {
        this.onCommandsObjectChange(event, ProductionFieldName.READRATE);
        this.onEnterEmitter.emit(this.command());
    }
}
